const eva_email_sign_in = {
    verify_email_continue: 'Verify your email to continue.',
    continue_redirect: 'Continue to EVA',
    empty_code: "Enter your verification code.",
    email_too_long: "This email address is too long.",
    password_policy: "Password does not meet the requirements.",
    reset_expired: "Your reset session has expired. Request a new code.",
    send_failed: "We couldn’t send the code. Please try again.",
    code_invalid: "This code is no longer valid. Request a new code.",
    rate_wait_one: 'Too many requests. Try again in {{minutes}} minute.',
    rate_wait: "Too many requests. Try again in {{minutes}} minutes.",
    oauth_cancelled: "Sign-in was canceled.",
    oauth_failed: "We couldn’t sign you in with {{provider}}. Please try again.",
    signed_in_continue: "You’re signed in. Continue to EVA.",
    email: 'Email address',
    code: 'Verification code',
    code_placeholder: 'Enter 6-digit code',
    password: 'Password',
    new_password: 'New password',
    confirm_password: 'Confirm new password',
    hide_password: 'Hide password',
    show_password: 'Show password',
    edit: 'Edit',
    send_wait: 'Send in {{seconds}}s',
    resend: 'Resend code',
    resend_wait: 'Resend in {{seconds}}s',
    continue: 'Continue',
    save_password: 'Save password',
    or: 'OR',
    google: 'Continue with Google',
    password_login: 'Continue with Password',
    code_login: 'Log in with a one-time code',
    forgot: 'Forgot password?',
    reset_title: 'Reset your password',
    entry_title: 'Log in or sign up',
    password_title: 'Log in with a password',
    verify_title: 'Verify your email',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    password_updated: 'Password updated. Log in with your new password.',
    code_sent: 'We sent a code to {{email}}',
    reset_sent: 'We sent a reset code to {{email}}',
    google_title: 'Connect Google',
    google_verify: 'Verify {{email}} to connect Google to your existing account.',
    verify_connect: 'Verify and connect',
    send_code: 'Send verification code',
    back: 'Back',
    restart: 'Start again',
    invalid_email: 'Enter a valid email address.',
    empty_email: 'Enter your email address.',
    empty_password: 'Enter your password.',
    invalid_code: 'Enter a 6-digit code.',
    password_mismatch: 'Passwords do not match.',
    wait_one: 'Please wait {{seconds}} second before requesting another code.',
    wait: 'Please wait {{seconds}} seconds before requesting another code.',
    network_error: 'Connection failed. Please try again.',
    service_error: 'Service temporarily unavailable. Please try again later.',
    unknown_error: 'Something went wrong. Please try again.',
    code_mismatch: 'Incorrect code. Please try again.',
    code_expired: 'This code has expired. Request a new code.',
    rate_limited: 'Too many requests. Please wait before trying again.',
    invalid_credentials: 'Incorrect password. Please try again.',
    suspended: 'This account is unavailable. Contact support.',
    captcha_required: 'Complete the security check to continue.',
    captcha_failed: 'Security check failed. Please try again.',
    session_expired: 'Your sign-in session has changed. Please start again.',
    locked: 'Too many attempts. Please try again later.',
    locked_wait: 'Too many attempts. Please try again in {{seconds}}s.',
    google_failed: 'Google sign-in was cancelled or could not be completed. Please try again.',
};
export default Object.freeze(eva_email_sign_in);
